// src/components/editors/ArrayEditor.tsx
import {
  Checkbox,
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@commenda/kakashi';
import { SupportedPropertyType, TSchemaObject } from '@commenda/types';
import Row from '../ui/Row';

export const ArrayEditor = ({
  schemaObject,
  onChange,
  renderPropertiesTable,
  showAdditionalProperties = false,
}: {
  schemaObject: TSchemaObject;
  onChange: (so: TSchemaObject) => void;
  renderPropertiesTable: (
    childSchemaObject: TSchemaObject[],
    onListChange: (list: TSchemaObject[]) => void
  ) => React.ReactNode;
  showAdditionalProperties?: boolean;
}) => {
  const defaultItems: TSchemaObject['items'] = {
    type: SupportedPropertyType.STRING,
    nestedProperties: [],
  };

  const items = schemaObject.items ?? defaultItems;

  return (
    <div className="space-y-2">
      <Row>
        <span className="txt-small-regular text-text-placeholder">
          Array items:
        </span>
        <Select
          value={items.type}
          onValueChange={(val: SupportedPropertyType) =>
            onChange({
              ...schemaObject,
              items: { type: val },
            })
          }
        >
          <SelectTrigger className="text-text-secondary txt-small-regular">
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="text-text-secondary txt-small-regular">
            {[
              SupportedPropertyType.STRING,
              SupportedPropertyType.NUMBER,
              SupportedPropertyType.BOOLEAN,
              SupportedPropertyType.OBJECT,
            ].map((propertyType) => (
              <SelectItem key={propertyType} value={propertyType}>
                {propertyType}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </Row>

      {items.type === SupportedPropertyType.OBJECT && (
        <div className="ml-2 flex flex-col gap-2">
          {showAdditionalProperties && (
            <div className="flex gap-2 justify-end">
              <Checkbox
                checked={schemaObject.items?.additionalProperties}
                onCheckedChange={(checked) =>
                  onChange({
                    ...schemaObject,
                    items: {
                      ...schemaObject.items,
                      additionalProperties: checked === true,
                    },
                  })
                }
              />
              <Label>Allow Additional Properties</Label>
            </div>
          )}
          {renderPropertiesTable(items.nestedProperties ?? [], (list) =>
            onChange({
              ...schemaObject,
              items: {
                type: SupportedPropertyType.OBJECT,
                nestedProperties: list,
              },
            })
          )}
        </div>
      )}
    </div>
  );
};
